import $ from "jquery";
import { fixFilePath } from "../useful";
import { Modal } from "bootstrap";

const orderId = window.location.pathname.split("/").pop();

const params = new URLSearchParams(window.location.search);
const shouldOpenEdit = (params.get("edit") || "").toLowerCase() === "true";

// Если модалка существует в DOM — открываем
if (shouldOpenEdit) {
  const $modal = $("#editOrderModal");
  if ($modal.length) {
    // Bootstrap 5
    const modalInstance = Modal.getOrCreateInstance($modal[0]);
    modalInstance.show();
  }
}

const editButton = $(".order__edit-save-button");

async function getOrder(id) {
  const { result } = await (await fetch(`/order/${id}`)).json();

  return result;
}

function getOrderChanges(oldOrder, form) {
  const formData = new FormData(form instanceof jQuery ? form[0] : form);
  const differences = {};

  for (let [key, value] of formData.entries()) {
    const oldValue = oldOrder[key] ?? "";

    const newVal = String(value).trim();
    const oldVal = String(oldValue).trim();

    if (key === "price") {
      differences[key] = value;
      continue;
    }

    if (newVal.length !== 0 && newVal !== oldVal) {
      differences[key] = value;
    }
  }

  return differences;
}

async function editOrder() {
  const prevData = await getOrder(orderId);
  const data = $("form.order__edit-form");

  const finalData = getOrderChanges(prevData, data);
  const finalForm = new FormData();

  for (let [key, val] of Object.entries(finalData)) {
    finalForm.append(key, val);
  }

  //Formatting date to the right string and setting it in form
  if (finalData.execution_at) {
    let myDate = finalData.execution_at;
    myDate = myDate.split(".");
    let newDate = new Date(myDate[2], myDate[1] - 1, myDate[0]);
    let finalDate = `${newDate.getFullYear()}-${
      newDate.getMonth() + 1
    }-${newDate.getDate()} ${newDate.toLocaleTimeString()}`;

    finalForm.set("execution_at", finalDate);
  }

  finalForm.delete("order__edit-add-file");
  finalForm.append("_method", "PATCH");

  console.log(finalData, finalForm);

  fetch(`/order/${orderId}`, {
    method: "POST",
    body: finalForm,
  })
    .then((res) => res.json())
    .then(() => {
      const url = new URL(window.location.href);

      url.searchParams.delete("edit");

      window.history.replaceState(
        {},
        document.title,
        url.pathname + (url.search ? url.search : ""),
      );

      location.reload();
    })
    .catch(console.error);
}

function renderImages(data) {
  const imageWrapper = $("#editOrderModal .files__wrapper");
  imageWrapper.html("");
  const files = JSON.parse(data.files).result;
  if (files.length >= 10) {
    $(".order__edit-files-add").hide();
  } else {
    $(".order__edit-files-add").show();
  }
  const imagesHTML = files
    .map(
      (file) => `
        <div class="position-relative rounded-4 flex justify-center align-items-center w80px h80px">
            <svg data-file="${fixFilePath(file)}" class="order__edit-delete-image position-absolute top-50 start-50 cursor-pointer translate-middle" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="30" height="30" rx="15" fill="#E14447" />
                <path d="M10 20L20 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M20 20L10 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <img src="${fixFilePath(file)}" class="rounded-3 w-100 h-100 border order__images-item object-fit-cover" alt="Изображение заказа">
        </div>
    `,
    )
    .join("");

  imageWrapper.append(imagesHTML);
}

function addImage(file) {
  const formData = new FormData();
  formData.append("id", orderId);
  formData.append("model", "Order");
  formData.append("field", "files");
  formData.append("files[]", file);

  return fetch("/api/files", {
    method: "POST",
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => {
      const order = Object.values(data.order)[0];
      renderImages(order);
    })
    .catch(console.error);
}

function deleteImage() {
  const fullPath = $(this).data("file"); // полный URL
  const path = fullPath.match(/(FileController|OrderController).*$/)?.[0];

  const data = {
    id: orderId,
    model: "Order",
    paths: [path],
  };

  fetch("/api/files", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => {
      console.log(data);
      const order = Object.values(data.order)[0];
      renderImages(order);
    })
    .catch(console.error);
}

$(document).on("click", ".order__edit-delete-image", deleteImage);

$("#order__edit-add-file").on("change", async function (e) {
  const file = e.target.files[0];
  if (!file) return;

  const response = await addImage(file);
  console.log(response);
});

editButton.on("click", editOrder);
